import * as React from "react";

import { cn } from "../../lib/utils";

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        "h-10 w-full rounded-md border border-border bg-[#0c0d10] px-3 text-sm text-foreground outline-none transition duration-200 placeholder:text-muted-foreground/70 focus:border-accent focus:ring-2 focus:ring-accent/25",
        className
      )}
      {...props}
    />
  )
);

Input.displayName = "Input";
